import { memo } from 'react';
import { paymentsCards } from 'src/constants';

const _FooterPaymentMethodsBlock = () => {
  return (
    <div className="flex flex-wrap items-center justify-center w-full my-7">
      {paymentsCards.map((element, index) => (
        <div className="flex items-center justify-center max-w-28 h-7 px-2.5 mt-2.5" key={index}>
          {element.image}
        </div>
      ))}
    </div>
  );
};

export const FooterPaymentMethodsBlock = memo(_FooterPaymentMethodsBlock);
